<template>
  <component
    v-if="node && node.child"
    :is="node['html-tag'] ? node['html-tag'] : 'div'"
    :class="node.class ? node.class : null"
    :style="node.style ? node.style : null"
    :to="node.link"
    :data-color="node['data-color']"
    :data-color-opacity="node['data-color-opacity']"
  >
    <RecursiveLevelSlot :node="node.child" style="width: 100%; height: 100%">
      <slot></slot>
    </RecursiveLevelSlot>
  </component>
  <component
    v-else
    :is="node && node['html-tag'] ? node['html-tag'] : 'div'"
    :class="node && node.class ? node.class : null"
    :style="node && node.style ? node.style : null"
    :to="node && node.link ? node.link : null"
    :data-color="node ? node['data-color'] : null"
    :data-color-opacity="node ? node['data-color-opacity'] : null"
  >
    <!-- :to="node && node.link ? node.link : ''" -->
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'RecursiveLevelSlot',
  props: ['node'],
};
</script>
